module.exports = __webpack_public_path__ + "img/statistics-default.44ab1a4d.svg";